import * as moment from 'moment'
import { Transaction } from './types'

export const mapTransactions = (transactions): Transaction[] => {
  return transactions.map(transaction => {
    switch (transaction.__typename) {
      case 'InitTransaction':
        return {
          id: transaction.id,
          type: 'INIT',
          createdOn: moment(transaction.createdOn),
          description: transaction.description,
          amount: transaction.amount,
          interest: transaction.interest
        }
      case 'PaymentTransaction':
        return {
          id: transaction.id,
          type: 'PAYMENT',
          createdOn: moment(transaction.createdOn),
          description: transaction.description,
          amount: transaction.amount
        }
      case 'CloseTransaction':
        return {
          id: transaction.id,
          type: 'CLOSE',
          createdOn: moment(transaction.createdOn),
          description: transaction.description
        }
      default:
        throw new Error(
          `Transaction of type: ${transaction.__typename} does not exists`
        )
    }
  })
}

export default mapTransactions



// WEBPACK FOOTER //
// ./src/utils/transactions/mapTransactions.tsx